import { createSlice } from '@reduxjs/toolkit'

const initialState = 
    {
        user: null,
        response: null,
        loading: false,
        error: null,
        callTimes: 0,
        message: '',
        data: []
    }

export const orderSliceDB = createSlice({
    name: 'orderSlicedb',
    initialState,
    reducers: {
        getOrderListDB: (state) => {
            state.loading = true
            state.error = null
        },
        getOrderDeatilsDB: (state) => {
            state.loading = true
            state.error = null
        },
        addOrderListDB: (state) => {
            state.loading = true
            state.error = null
        },
        removeOrderListDB: (state) => {
            state.loading = true
            state.error = null
        },
        updateOrderListDB: (state) => {
            state.loading = true
            state.error = null
        },
        successOrderListDB: (state, action) => {
            state.data = action.payload
            state.loading = false
            state.error = null
        },
        failedOrderListDB: (state, action) => {
            state.loading = false
            state.error = action.payload
        },
        updateOrderStatusInList: (state, action) => {
            const { id, status, tracking_url } = action.payload;
            const updateInArray = (arr) =>
                arr.map((o) => {
                    const oid = o?.id || o?.order_id || o?.orderId || o?._id;
                    if (oid == id) {
                        return { ...o, status, order_status: status, orderStatus: status, tracking_url };
                    }
                    return o;
                });
            if (Array.isArray(state.data)) {
                state.data = updateInArray(state.data);
            } else if (state.data?.orders && Array.isArray(state.data.orders)) {
                state.data = { ...state.data, orders: updateInArray(state.data.orders) };
            }
            state.loading = false;
        },
    },
})

export const { getOrderListDB, getOrderDeatilsDB, addOrderListDB, removeOrderListDB, updateOrderListDB, successOrderListDB, failedOrderListDB, updateOrderStatusInList } = orderSliceDB.actions

export default orderSliceDB.reducer
